
import { lonlats2cartesians } from "../../utils/CoordinateUtil"
import DrawBase from "../DrawBase"
import EditSquadCombat from "./EditSquadCombat"
import StyleUtil from "@/utils/cesiumBD/utils/StyleUtil.js"
const Place_T = 0.4;
const FITTING_COUNT = 100
const HALF_PI = Math.PI / 2
const ZERO_TOLERANCE = 0.000003
const TWO_PI = Math.PI * 2
const ERADIUS = 6378137; //赤道半径
const PRADIUS = 6356725; //极半径

class DrawSquadCombat extends DrawBase {


    constructor(options) {
        super(options);
        this.initConsts();
    }

    getEditInterface() {
        return EditSquadCombat;
    }


    getTypeName() {
        return "分队战斗";
    }

    getType() {
        return "polygon_Nor";
    }
    checkMouseMove() {
        if (this.positionsTemp.length <= 1) {
            return false;
        }
        return true;
    }
    addDynamicGraph(entity) {
        var $this = this;
        var positionsArr = undefined;
        var positions = [];
        var hierarchyProperty = new $this.Cesium.CallbackProperty(function () {
            $this.calculateKeyPositions();
            if (!$this.isStarted && !positionsArr) {
                positionsArr = $this.positions.slice();
            }
            positions = positionsArr ? positionsArr : $this.positions;
            return new $this.Cesium.PolygonHierarchy($this.computeSquadCombat(positions));

        }, false);

        var polygon = this.createPolygon(hierarchyProperty);
        entity.polygon = polygon;
    }

    loadDynamicGraph(entity, data) {
        var $this = this;
        var positions = JSON.parse(data.editPositions);
        var hierarchyProperty = new $this.Cesium.CallbackProperty(function () {
            return new $this.Cesium.PolygonHierarchy($this.computeSquadCombat(positions));
        }, true);

        var polygon = this.createPolygon(hierarchyProperty);
        entity.polygon = polygon;
        StyleUtil.setStyle2Entity(JSON.parse(data.styleAttr), entity, "polygon")
    }

    initConsts() {
        this.headHeightFactor = 0.18;
        this.headWidthFactor = 0.3;
        this.neckHeightFactor = 0.85;
        this.neckWidthFactor = 0.15;
        this.tailWidthFactor = 0.1;
    }

    computeSquadCombat(positions) {
        var pnts = this.cart2Wgs84(positions);
        var res = this.generate(pnts);
        var list = lonlats2cartesians(res);
        return list;
    }

    generate(pnts) {
        var that = this;
        if (that.distance(pnts[pnts.length-1], pnts[pnts.length-2]) < 0.000003) {
            pnts=pnts.slice(0,pnts.length-1);
        }
        var tailPnts = this.getTailPoints(pnts);
        var headPnts = this.getArrowHeadPoints(pnts, tailPnts[0], tailPnts[1]);
        var neckLeft = headPnts[0];
        var neckRight = headPnts[4];
        var bodyPnts = this.getArrowBodyPoints(pnts, neckLeft, neckRight, this.tailWidthFactor);
        var count = bodyPnts.length;
        var leftPnts = [tailPnts[0]].concat(bodyPnts.slice(0, count / 2));
        leftPnts.push(neckLeft);
        var rightPnts = [tailPnts[1]].concat(bodyPnts.slice(count / 2, count));
        rightPnts.push(neckRight);

        leftPnts = that.getQBSplinePoints(leftPnts);
        rightPnts = that.getQBSplinePoints(rightPnts);
        var pList = leftPnts.concat(headPnts, rightPnts.reverse());
        return pList;
    }

    getTailPoints(points) {
        var that = this;
        var allLen = that.getBaseLength(points);
        var tailWidth = allLen * this.tailWidthFactor;
        var tailLeft = that.getThirdPoint(points[1], points[0], HALF_PI, tailWidth, false);
        var tailRight = that.getThirdPoint(points[1], points[0], HALF_PI, tailWidth, true);
        return [tailLeft, tailRight];
    }

    getArrowHeadPoints(points, tailLeft, tailRight) {
        var that = this;
        var len = that.getBaseLength(points);
        var headHeight = len * this.headHeightFactor;
        var headPnt = points[points.length - 1];
        len = that.distance(headPnt, points[points.length - 2]);
        var tailWidth = that.distance(tailLeft, tailRight);
        if (headHeight > tailWidth * this.headTailFactor) {
            headHeight = tailWidth * this.headTailFactor;
        }
        var headWidth = headHeight * this.headWidthFactor;
        var neckWidth = headHeight * this.neckWidthFactor;
        headHeight = headHeight > len ? len : headHeight;
        var neckHeight = headHeight * this.neckHeightFactor;
        var headEndPnt = that.getThirdPoint(points[points.length - 2], headPnt, 0, headHeight, true);
        var neckEndPnt = that.getThirdPoint(points[points.length - 2], headPnt, 0, neckHeight, true);
        var headLeft = that.getThirdPoint(headPnt, headEndPnt, HALF_PI, headWidth, false);
        var headRight = that.getThirdPoint(headPnt, headEndPnt, HALF_PI, headWidth, true);
        var neckLeft = that.getThirdPoint(headPnt, neckEndPnt, HALF_PI, neckWidth, false);
        var neckRight = that.getThirdPoint(headPnt, neckEndPnt, HALF_PI, neckWidth, true);
        return [neckLeft, headLeft, headPnt, headRight, neckRight];
    }

    getArrowBodyPoints(points, neckLeft, neckRight, tailWidthFactor) {
        var that = this;
        var allLen = that.wholeDistance(points);
        var len = that.getBaseLength(points);
        var tailWidth = len * tailWidthFactor;
        var neckWidth = that.distance(neckLeft, neckRight);
        var widthDif = (tailWidth - neckWidth) / 2;
        var tempLen = 0,
            leftBodyPnts = [],
            rightBodyPnts = [];
        for (var i = 1; i < points.length - 1; i++) {
            var angle = that.getAngleOfThreePoints(points[i - 1], points[i], points[i + 1]) / 2;
            tempLen += that.distance(points[i - 1], points[i]);
            var w = (tailWidth / 2 - tempLen / allLen * widthDif) / Math.sin(angle);
            var left = that.getThirdPoint(points[i - 1], points[i], Math.PI - angle, w, true);
            var right = that.getThirdPoint(points[i - 1], points[i], angle, w, false);
            leftBodyPnts.push(left);
            rightBodyPnts.push(right);
        }
        return leftBodyPnts.concat(rightBodyPnts);
    }

    getAngleOfThreePoints(pntA, pntB, pntC) {
        var that = this;
        let angle = that.getAzimuth(pntB, pntA) - that.getAzimuth(pntB, pntC)
        return ((angle < 0) ? (angle + Math.PI * 2) : angle)
    }
    getThirdPoint(startPnt, endPnt, angle, distance, clockWise) {
        var that = this;
        let azimuth = that.getAzimuth(startPnt, endPnt)
        let alpha = clockWise ? (azimuth + angle) : (azimuth - angle)
        let dx = distance * Math.cos(alpha)
        let dy = distance * Math.sin(alpha)
        return ([endPnt[0] + dx, endPnt[1] + dy])
    }



    getAzimuth(t, o) {
        var e, r = Math.asin(Math.abs(o[1] - t[1]) / this.distance(t, o));
        return o[1] >= t[1] && o[0] >= t[0] ? e = r + Math.PI : o[1] >= t[1] && o[0] < t[0] ? e = 2 * Math.PI - r : o[1] < t[1] && o[0] < t[0] ? e = r : o[1] < t[1] && o[0] >= t[0] && (e = Math.PI - r), e
    }

    getQBSplinePoints(points) {
        var that = this;
        if (points.length <= 2) {
            return points
        } else {
            let [n, bSplinePoints] = [2, []]
            let m = points.length - n - 1
            bSplinePoints.push(points[0])
            for (let i = 0; i <= m; i++) {
                for (let t = 0; t <= 1; t += 0.05) {
                    let [x, y] = [0, 0]
                    for (let k = 0; k <= n; k++) {
                        let factor = that.getQuadricBSplineFactor(k, t)
                        x += factor * points[i + k][0]
                        y += factor * points[i + k][1]
                    }
                    bSplinePoints.push([x, y])
                }
            }
            bSplinePoints.push(points[points.length - 1])
            return bSplinePoints
        }
    }
    getQuadricBSplineFactor(k, t) {
        let res = 0
        if (k === 0) {
            res = Math.pow(t - 1, 2) / 2
        } else if (k === 1) {
            res = (-2 * Math.pow(t, 2) + 2 * t + 1) / 2
        } else if (k === 2) {
            res = Math.pow(t, 2) / 2
        }
        return res
    }
    getBaseLength(points) {
        var that = this;
        return Math.pow(that.wholeDistance(points), 0.99)
    }

    wholeDistance(points) {
        var that = this;
        let d = 0
        if (points && Array.isArray(points) && points.length > 0) {
            points.forEach((item, index) => {
                if (index < points.length - 1) {
                    d += (that.distance(item, points[index + 1]))
                }
            })
        }
        return d
    }

    distance(pnt1, pnt2) {
        return (Math.sqrt(Math.pow((pnt1[0] - pnt2[0]), 2) + Math.pow((pnt1[1] - pnt2[1]), 2)))
    }
}

export default DrawSquadCombat